import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AlertInterface } from '../../interfaces/alert.interface';
import { APP_ROUTES } from '../../constants/app-routes.constant';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})
export class AlertBoxComponent {
  @Input() alertData: AlertInterface;
  @Input() icon = true;

  constructor(private router: Router) {}

  public handleClick() {
    if (this.alertData.possuiLink) {
      if (this.alertData.externo) {
        this.router.navigate([`${APP_ROUTES.services.url}/${this.alertData.nroIntCodigoTipoSolicitacao}`]);
      } else {
        this.router.navigate([
          `${APP_ROUTES.services.url}/${this.alertData.nroIntCodigoTipoSolicitacao}/${APP_ROUTES.services.subChildren.accessService.url}`
        ]);
      }
    }
  }
}
